import { gql } from '@apollo/client'

export const REPORT_CHATBOT_MESSAGE = gql`
  mutation reportChatbotMessage(
    $botMessageId: ID!
    $reason: ChatbotMessageReportReason!
    $note: String
  ) {
    reportChatbotMessage(botMessageId: $botMessageId, reason: $reason, note: $note) {
      id
    }
  }
`
